import { IPromoItem, IPromoItemDetails } from 'app/modules/promo/promoTypes';
import * as actions from './promoConstants';

export const setPromoIsFetching = () => ({
	type: actions.SET_PROMO_IS_FETCHING,
});

export const getPromosSuccess = (payload: IPromoItem[]) => ({
	type: actions.GET_PROMOS_SUCCESS,
	payload,
});

export const getPromosFail = (error: Error) => ({
	type: actions.GET_PROMOS_FAIL,
	error,
});

export const getPromoItemSuccess = (promoItem: IPromoItemDetails) => ({
	type: actions.GET_PROMO_ITEM_SUCCESS,
	promoItem,
});

export const resetPromos = () => ({
	type: actions.RESET_PROMOS,
});
